import { Link } from "react-router-dom";
import { useState, } from "react";
import React from "react";
import Footer from "./Footer";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "./modals/modal";
import AITraining from "../images/AITraining.png";
import AiRobot from "../images/AiRobot.png";
// import "../App.css";

const Body = () => {
  const [currentItem, setCurrentItem] = useState(null);

  const modulesData = [
  {
    title: "Introduction to NLP",
    content:
      "Learn the fundamentals of Natural Language Processing (NLP), its goals, and how it enables machines to understand and generate human language.",
  },
  {
    title: "AI/NLP Methods",
    content:
      "Explore how Machine Learning and Deep Learning methods power NLP systems, from classical algorithms to modern neural networks.",
  },
  {
    title: "Model Building Pipeline",
    content:
      "Understand the full pipeline of building an NLP model — from data preprocessing and feature extraction to model training and evaluation.",
  },
  {
    title: "Feature Engineering",
    content:
      "Discover techniques for text representation like Bag of Words, TF-IDF, and Word Embeddings that help models understand text data effectively.",
  },
  {
    title: "Transformers",
    content:
      "Dive into Transformer architectures that revolutionized NLP — the backbone of models like BERT, GPT, and T5.",
  },
  {
    title: "Large Language Models",
    content:
      "Learn about large-scale models such as GPT, how they’re trained, and how they understand, generate, and reason with human-like text.",
  },
  {
    title: "Prompt Engineering",
    content:
      "Master the art of designing prompts to optimize AI model responses — a crucial skill in interacting with advanced language models.",
  },
  {
    title: "Explainable AI",
    content:
      "Explore methods that make AI decisions interpretable and transparent, ensuring responsible and trustworthy AI systems.",
  },
  {
    title: "Commercial AI Applications",
    content:
      "See how NLP and AI are integrated into real-world products — from chatbots to recommendation systems and virtual assistants.",
  },
];
  const steps = [
    {
      title: "Learn the Concepts",
      description:
        "Get bite-sized explanations of key NLP concepts, written in clear and concise language.",
    },
    {
      title: "Test the Concepts",
      description:
        "Dive into practical exercises for each concept. Run pre-written Python code and see real applications.",
    },
    {
      title: "Try it",
      description:
        "Test your understanding by writing your own Python code to implement the concepts you've learned.",
    },
  ];

  const [modal, setModal] = useState({
    state: false,
    type: "",
    value: null,
  });

  const [activeContent, setActiveContent] = React.useState(
    "Hover over a module to see its details here."
  );
  const [isFading, setIsFading] = React.useState(false);

  const timeoutRef = React.useRef(null);

  const handleHover = (content) => {
    // clear any previous fade timers
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  
    setIsFading(true); // start fade out
  
    timeoutRef.current = setTimeout(() => {
      setActiveContent(content); // switch text after fade out
      setIsFading(false);        // fade back in
    }, 300); // matches your transition duration
  };

  React.useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  return (
    <div className="h-full">
  {/* Features */}
  <div className="flex flex-col w-full">
    <section className="flex flex-col justify-center bg-[#021732] text-white p-6">
      <div className="flex flex-col lg:flex-row justify-between items-center pt-12 gap-8">
        <div className="flex flex-col justify-center items-center text-center px-4">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-4">
          All Aspects of AI Through its History Explained With Practical Examples 
          </h1>
          <p className="text-lg md:text-2xl mb-6">
            Through Self-Guided Software Designed by AI Experts
          </p>
          <Link to="/learn" className="border-2 px-4 py-2 rounded-md text-xl mt-4">
            Learn More
          </Link>
        </div>
        <img className="w-full max-w-md mx-auto lg:mt-0" src={AITraining} alt="AITraining" />
      </div>

      <h2 className="text-2xl md:text-3xl font-semibold text-center pt-20 mb-8">
        Our Simple, Powerful and Practical Approach
      </h2>

      <div className="flex flex-col lg:flex-row lg:space-x-6 px-4">
        {steps.map((step) => (
          <div
            key={step.title}
            className="bg-white md:hover:scale-105 p-6 rounded-lg shadow-lg mb-6 lg:mb-0"
          >
            <h3 className="text-2xl text-sky-700 font-bold text-center">{step.title}</h3>
            <p className="mt-3 text-black text-center">{step.description}</p>
          </div>
        ))}
      </div>
    </section>

    {/* Modules */}
    <div className="text-center my-10 px-4">
      <h2 className="text-4xl font-bold text-sky-700 mb-4">Modules</h2>
      <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto font-semibold">
        Dive into the fascinating world of Natural Language Processing (NLP) with our carefully curated modules. Whether you're a beginner exploring the basics or an enthusiast eager to master advanced topics, these modules are designed to guide you step by step. <br />
        Hover over each topic to learn more!
      </p>
    </div>

    {/* Circle UI for md and above */}
    <div className="hidden md:flex flex-col items-center justify-center min-h-screen">
    <div className="relative w-full h-[750px] lg:h-[850px]">
        {/* Center Circle with Fade Animation */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-white border-4 border-sky-700 rounded-full flex items-center justify-center text-center p-10 shadow-xl z-10">
          <p
            className={`text-gray-800 font-semibold text-lg leading-relaxed transition-opacity duration-300 ${
              isFading ? "opacity-0" : "opacity-100"
            }`}
          >
            {activeContent}
          </p>
        </div>

        {/* Surrounding Circles */}
        {modulesData.map((module, index) => {
          const angle = (360 / modulesData.length) * index;
          const radius = 250; // reduced from 300 → tighter spacing
          const x = radius * Math.cos((angle * Math.PI) / 180);
          const y = radius * Math.sin((angle * Math.PI) / 180);
          return (
            <div
            key={index}
            className="absolute w-40 h-40 bg-sky-700 text-white rounded-full flex items-center justify-center shadow-md cursor-pointer transition-transform duration-300 hover:scale-110 hover:bg-sky-600"
            style={{
              left: `calc(50% + ${x}px - 80px)`,
              top: `calc(50% + ${y}px - 80px)`,
            }}
            onMouseEnter={() => setActiveContent(module.content)}
            onMouseLeave={() =>
              setActiveContent("Hover over a module to see its details here.")
            }
          >
            <p className="text-center text-base px-3 font-medium">
              {module.title}
            </p>
          </div>

          );
        })}
      </div>
    </div>

    {/* Fallback for small devices */}
    <div className="md:hidden px-4 space-y-4 mt-6">
      {modulesData.map((module, index) => (
        <div key={index} className="bg-sky-700 text-white p-4 rounded-lg shadow">
          <h4 className="text-lg font-bold">{module.title}</h4>
          <p className="text-sm">{module.content}</p>
        </div>
      ))}
    </div>

    {/* Reasons */}
    <div className="bg-gray-200 pt-8 md:pt-16 px-4 md:px-14 mt-16 pb-12">
      <div className="text-center mb-10">
        <h1 className="font-semibold text-2xl md:text-4xl text-black">
          Easiest Way to Learn AI: Our <span className="text-sky-700">SelfTrainAI</span> Platform
        </h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        <div>
          <h3 className="text-2xl font-bold mb-2 text-sky-700 text-center">Interactive Interface</h3>
          <p className="text-gray-700 text-lg text-center">
            User-friendly platform designed for optimal learning experience
          </p>
        </div>
        <div>
          <h3 className="text-2xl font-bold mb-2 text-sky-700 text-center">All Skill Levels</h3>
          <p className="text-gray-700 text-lg text-center">
            Suitable for both beginners and advanced practitioners
          </p>
        </div>
        <div>
          <h3 className="text-2xl font-bold mb-2 text-sky-700 text-center">Video Explanations</h3>
          <p className="text-gray-700 text-lg text-center">
          Detailed video guides available for every topic to simplify learning
          </p>
        </div>
      </div>
    </div>

    {/* Modal */}
    <Modal
      isOpen={modal["state"]}
      close={() => setModal({ state: false, type: "Add", value: null })}
      width="md:w-3/4"
    >
      <ModalHeader
        title={modal?.value?.text}
        close={() => setModal({ state: false, type: "" })}
      />
      <ModalBody>
        <div className="pt-3">{modal?.value?.learnMore}</div>
      </ModalBody>
    </Modal>

    <Footer />
  </div>
</div>

  );
};

export default Body;
